import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Ubuntu release party, start:up and weed",
  "description": "",
  "published": "2009-10-30T00:00:00.000Z",
  "redirect_from": ["/blog/ubuntu-release-party-startup-and-weed/swizec/788"],
  "categories": "Entrepreneur, Kiberpipa, life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Weeds_title_card.jpg"
          }}><img parentName="a" {...{
              "src": "https://upload.wikimedia.org/wikipedia/en/thumb/f/f3/Weeds_title_card.jpg/300px-Weeds_title_card.jpg",
              "alt": "Weeds",
              "title": "Weeds"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Weeds_title_card.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`But mostly the weed.`}</p>
    <p>{`Guess who I bought weed from last night? ... that's right, the only two niggers in Ljubljana! So few of them and that's the first industry they get into! xD (it was a bit expensive, but very fine though)`}</p>
    <p>{`Anyhow, the Karmic Koala was released yesterday and there was a great party in its honor last night at `}<a parentName="p" {...{
        "href": "http://www.kiberpipa.org",
        "title": "Kiberpipa"
      }}>{`Kiberpipa`}</a>{`. It was pretty cool to say the least, lots of geeks all in one place, free beer and PIE! Pie people! I like pie. Oh and the introductory lecture thingy was bloody awesome.`}</p>
    <p>{`Also yesterday was the day of start:up 100% entrepreneur forum blahblah event thingy. That was an all 'round marvelous event and I learned a lot. My presentation also went ridiculously well and that makes me a bit happy. I spent four hours making that stupid thing, it better work!`}</p>
    <p>{`Unfortunately though, most of the other presenters didn't seem like they've invested the same kind of attention in their presentations. They were for the most part ridiculously full of text, a bit mundane and essentially very somewhat 'corporate'. I hate that style of anything.`}</p>
    <p>{`Startups are supposed to be, in my mind, hip and cool, not strive to being boring and corporate too soon in their lives.`}</p>
    <p>{`Oh and I have to mention this ... organizers ... if you call it "lunch of networking", please for the love of god, provide some free food or something, even just canapes, and keep us all in the same bloody building. The free cookies were marvelous though, omnomnom.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/640fcdb9-785a-41ed-a878-a9bf4a296e5a/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=640fcdb9-785a-41ed-a878-a9bf4a296e5a",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      